module.exports = __webpack_public_path__ + "img/long-term-cache/awards.bfde9d7d1725ed016269d3979feb5374.png";